const AccountStateType = 
{
    'ACTIVE': '활성',
    'EXPIRED': '만료',
    'LOCKED': '잠김',
    'DISABLED': '장애'
}
export default AccountStateType